/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto.  Keeping your custom
 * Javascript in this fill will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
	// Style shopify-payment-terms shadow DOM
	function stylePaymentTerms(el) {
		var root = el.shadowRoot;
		if (!root) return;

		var style = document.createElement('style');
		style.textContent = 'p { font-size: 12px; }';
		root.appendChild(style);
	}

	var terms = document.querySelector('shopify-payment-terms');
	if (terms) {
		if (terms.shadowRoot) {
			stylePaymentTerms(terms);
		} else {
			new MutationObserver(function (_, obs) {
				if (terms.shadowRoot) {
					stylePaymentTerms(terms);
					obs.disconnect();
				}
			}).observe(terms, { childList: true, subtree: true });
		}
	}
})();
